import angular from 'angular'

import { adminRoutes } from './admin.routes'

import { adminService } from './services/admin.service'
import { generalSettingsService } from './services/general-settings.service'
import { productsService } from './services/products-admin.service'
import { productsFrameService } from './services/products-frame.service'
import { customerConfigurationsService } from './services/customer-configurations.service'
import { customerCompanyService } from './services/customer-company.service'
import { customerSegmentsService } from './services/customer-segments.service'
import { accountManagementService } from './services/account-management.service'
import { tagsService } from './services/tags.service'
import { formatService } from './services/formats.service'
import { conditionalService } from './services/conditional.service'

import { expirationFilter } from './filters/filter-expiration.filter'

import { expiration } from './directives/expiration/expiration.directive'
import { inputCampaignThumb } from './directives/input-campaign-thumb/input-campaign-thumb.directive'
import { licenseCard } from './directives/license-card/license-card.directive'
import { licenseCardSimplified } from './directives/license-card-simplified/license-card-simplified.directive'
import { storageAmountCard } from './directives/storage-amount-card/storage-amount-card.directive.js'
import { customerSegmentDirective } from './directives/customer-segment/customer-segment.directive'
import { plan } from './directives/plan/plan.directive'
import { conditional } from './directives/conditional/conditional.directive'
import { warningBanner } from './directives/warning-banner/warning-banner.directive'
import { addProductLoading } from './directives/add-product-loading/add-product-loading.directive'
import { productsTable } from './directives/products-table/products-table.directive'
import { backofficeGeneralSettingsDirective } from './directives/backoffice-general-settings/backoffice-general-settings.directive'

import { importUsersDialogDirective } from './dialogs/import-users/import-users-dialog.directive'
import { requestQuoteDialog } from './dialogs/request-quote/request-quote-dialog.directive'
import { requestStorageDialog } from './dialogs/request-storage/request-storage-dialog.directive'
import { inviteTeamMembersDialogDirective } from './dialogs/invite-team-members/invite-team-members-dialog.directive'
import { deleteUserDialogNew } from './dialogs/delete-user-new/delete-user-dialog-new.directive'
import { deleteAdminDesignerDialog } from './dialogs/delete-admin-designer/delete-admin-designer-dialog.directive'
import { deleteUserNoMovimentationDialog } from './dialogs/delete-user-no-movimentation/delete-user-no-movimentation-dialog.directive'
import { addCompanyDialogDirective } from './dialogs/add-company/add-company-dialog.directive'
import { restoreUserDialogNew } from './dialogs/restore-user-new/restore-user-dialog-new.directive'
import { editUserDataFieldsDialog } from './dialogs/edit-user-data-fields/edit-user-data-fields.directive'
import { createTag } from './dialogs/create-tag/create-tag.directive'
import { createTaskTag } from './dialogs/create-task-tag/create-task-tag.directive'
import { createFormat } from './dialogs/create-format/create-format.directive'
import { newGroupDialogDirective } from './dialogs/new-group/new-group-dialog.directive.js'
import { deleteGroupDialogDirective } from './dialogs/delete-group/delete-group-dialog.directive.js'
import { inviteGuestsDialogDirective } from './dialogs/invite-guests/invite-guests-dialog.directive'
import { editGuestDialog } from './dialogs/edit-guest/edit-guest-dialog.directive'
import { guestPermissionsDialog } from './dialogs/guest-permissions/guest-permissions-dialog.directive'
import { addProductStepByStepDialog } from './dialogs/add-product-step-by-step/add-product-step-by-step.directive'
import { addProductDialog } from './dialogs/add-product/add-product.directive'
import { editProductDialog } from './dialogs/edit-product/edit-product.directive'
import { importGuestsDialogDirective } from './dialogs/import-guests/import-guests-dialog.directive'
import { backofficeBusinessDataDirective } from './directives/backoffice-business-data/backoffice-business-data.directive'

const module = angular
  .module('deskfy.admin', [])
  .config(adminRoutes)
  .factory('AdminService', adminService)
  .factory('GeneralSettingsService', generalSettingsService)
  .factory('ProductsService', productsService)
  .factory('ProductsFrameService', productsFrameService)
  .factory('CustomerConfigurationsService', customerConfigurationsService)
  .factory('CustomerSegmentsService', customerSegmentsService)
  .factory('AccountManagementService', accountManagementService)
  .factory('CustomerCompanyService', customerCompanyService)
  .factory('TagsService', tagsService)
  .factory('FormatService', formatService)
  .factory('ConditionalService', conditionalService)
  .filter('expirationFilter', expirationFilter)
  .directive('expiration', expiration)
  .directive('deleteUserDialogNew', deleteUserDialogNew)
  .directive('deleteAdminDesignerDialog', deleteAdminDesignerDialog)
  .directive('deleteUserNoMovimentationDialog', deleteUserNoMovimentationDialog)
  .directive('restoreUserDialogNew', restoreUserDialogNew)
  .directive('inputCampaignThumb', inputCampaignThumb)
  .directive('licenseCard', licenseCard)
  .directive('licenseCardSimplified', licenseCardSimplified)
  .directive('storageAmountCard', storageAmountCard)
  .directive('customerSegment', customerSegmentDirective)
  .directive('plan', plan)
  .directive('conditional', conditional)
  .directive('addCompanyDialog', addCompanyDialogDirective)
  .directive('importUsersDialog', importUsersDialogDirective)
  .directive('requestQuoteDialog', requestQuoteDialog)
  .directive('requestStorageDialog', requestStorageDialog)
  .directive('inviteTeamMembersDialog', inviteTeamMembersDialogDirective)
  .directive('editUserDataFieldsDialog', editUserDataFieldsDialog)
  .directive('createTag', createTag)
  .directive('createTaskTag', createTaskTag)
  .directive('createFormat', createFormat)
  .directive('newGroupDialog', newGroupDialogDirective)
  .directive('deleteGroupDialog', deleteGroupDialogDirective)
  .directive('inviteGuestsDialog', inviteGuestsDialogDirective)
  .directive('editGuestDialog', editGuestDialog)
  .directive('guestPermissionsDialog', guestPermissionsDialog)
  .directive('addProductStepByStepDialog', addProductStepByStepDialog)
  .directive('warningBanner', warningBanner)
  .directive('addProductLoading', addProductLoading)
  .directive('addProductDialog', addProductDialog)
  .directive('editProductDialog', editProductDialog)
  .directive('productsTable', productsTable)
  .directive('importGuestsDialog', importGuestsDialogDirective)
  .directive('backofficeGeneralSettings', backofficeGeneralSettingsDirective)
  .directive('backofficeBusinessData', backofficeBusinessDataDirective)

export const adminModule = module
